import type { IGlobalSetting } from '~/modules/global-setting/types/globalSetting';
import { create } from 'zustand';

export interface IGlobalSettingStore {
  globalSetting?: IGlobalSetting;
  globalSettingEditing: IGlobalSetting;
  isQueryGlobalSetting: boolean;
  setGlobalSetting: (globalSetting: IGlobalSetting) => void;
  updateAdditionalSelector: (field: keyof IGlobalSetting, value: string[]) => void;
  setIsQueryGlobalSetting: (isQueryGlobalSetting: boolean) => void;
}

export const useGlobalSettingStore = create<IGlobalSettingStore>()((set) => ({
  globalSetting: undefined,
  globalSettingEditing: {
    configPriceSelectors: [],
    configComparePriceSelectors: [],
  },
  isQueryGlobalSetting: false,
  setGlobalSetting: (globalSetting) => set({ globalSetting }),
  updateAdditionalSelector: (field, value) => {
    set((state) => {
      return {
        globalSettingEditing: {
          ...state.globalSettingEditing,
          [field]: value,
        },
      };
    });
  },
  setIsQueryGlobalSetting: (isQueryGlobalSetting) => set({ isQueryGlobalSetting }),
}));
